import { NgModule } from '@angular/core';

import { AnalyticsCoreModule } from '../../analytics-core/analytics-core.module';
import { ContentComponent } from './components/content.component';

@NgModule({
	bootstrap: [ContentComponent],
	declarations: [ContentComponent],
	exports: [ContentComponent],
	imports: [AnalyticsCoreModule]
})
export class ContentModule {}
